<template>
  <button :disabled="disabled" :class="[$style.button, isFollowed && $style.isFollowed, small && $style.small]" :title="small ? buttonText : ''" :aria-label="small ? buttonText : ''" @click="onClick">
    <span v-if="isFollowed"
      ><HeartFillSvg :class="$style.heartIcon" /><template v-if="!small">{{ buttonText }}</template></span
    >
    <span v-else
      ><HeartActiveSvg :class="$style.heartIcon" /><template v-if="!small">{{ buttonText }}</template></span
    >
  </button>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { followMember, unFollowMember } from '@/js/lib/api/v1/member';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import HeartActiveSvg from '@/svgs/vue/heart-active.svg';
import HeartFillSvg from '@/svgs/vue/heart-fill.svg';

const props = defineProps<{
  disabled: boolean;
  memberId: number;
  small?: boolean;
}>();
const userStore = useUserStore();
const memberStore = useMemberStore();
const isLoading = ref(false);
const isFollowed = computed(() => memberStore.followedMemberIds.includes(props.memberId));
const buttonText = computed(() => (isFollowed.value ? 'お気に入りに追加済' : 'お気に入りショップに追加'));
const follow = async () => {
  memberStore.addFollowedMemberId(props.memberId);
  await followMember({ memberId: props.memberId }).catch(() => {
    memberStore.removeFollowedMemberId(props.memberId);
  });

  window.dataLayer?.push({
    event: 'follow',
    event_category: 'kpi',
    event_label: 'shop',
  });
};
const unfollow = async () => {
  memberStore.removeFollowedMemberId(props.memberId);
  await unFollowMember({ memberId: props.memberId }).catch(() => {
    memberStore.addFollowedMemberId(props.memberId);
  });
};
const onClick = async () => {
  if (userStore.isAuthenticated) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    await (isFollowed.value ? unfollow() : follow());
    isLoading.value = false;
  } else {
    signinSignup({
      next: window.location.href,
      callback: async () => {
        await loading({
          asyncFunc: async () => {
            await follow();
            window.location.reload();
          },
          text: 'ログインしています',
        });
      },
    });
  }
};
</script>

<style module lang="scss">
.button {
  background-color: var(--color-white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  display: block;
  padding: 6px 14px 6px 10px;
  position: relative;
  text-decoration: none;
  width: 100%;

  &:not(:disabled) {
    cursor: pointer;

    :hover {
      opacity: 0.8;
      text-decoration: none;
    }
  }

  &:disabled {
    color: var(--color-gray500);
    cursor: not-allowed;

    .heartIcon {
      fill: var(--color-gray500);
    }
  }

  &.small {
    border: none;
    font-size: 12px;
    padding: 0;
    width: auto;

    .heartIcon {
      margin-right: 0;
      width: 30px;
    }
  }

  &.isFollowed {
    background-color: var(--action-button-background-color);

    &.small {
      background: none;
    }

    .heartIcon {
      fill: var(--action-button-heart-color);
    }
  }

  > span {
    align-items: center;
    display: flex;
    justify-content: center;

    .heartIcon {
      fill: var(--color-gray900);
      margin-right: 6px;
      width: 20px;
    }
  }
}
</style>
